import ApiService from './apiService';

/**
 * Service pour gérer les transactions de portefeuille client
 */
class CustomerWalletTransactionService {
    /**
     * Récupérer la liste des transactions avec filtres et pagination
     * @param {Object} params Paramètres de filtrage et pagination
     * @param {String} [params.search] Recherche par référence ou description
     * @param {Number} [params.per_page] Nombre d'éléments par page (défaut: 15, max: 100)
     * @param {Number} [params.page] Numéro de page
     * @param {String} [params.type] Type de transaction (credit, debit, refund)
     * @param {Number} [params.customer_id] ID du client
     * @param {Number} [params.wallet_id] ID du portefeuille
     * @param {String} [params.start_date] Date de début (format: YYYY-MM-DD)
     * @param {String} [params.end_date] Date de fin (format: YYYY-MM-DD)
     * @param {Number} [params.min_amount] Montant minimum
     * @param {Number} [params.max_amount] Montant maximum
     * @param {String} [params.sort_by] Champ de tri (created_at, amount, type, balance_after)
     * @param {String} [params.sort_direction] Direction du tri (asc, desc)
     * @returns {Promise} Réponse de l'API avec la liste des transactions
     */
    getWalletTransactions(params = {}) {
        return ApiService.get('/wallet-transactions', params);
    }

    /**
     * Récupérer une transaction par son ID
     * @param {Number} id ID de la transaction
     * @returns {Promise} Réponse de l'API avec les détails de la transaction
     */
    getWalletTransaction(id) {
        return ApiService.get(`/wallet-transactions/${id}`);
    }

    /**
     * Récupérer les transactions d'un portefeuille spécifique
     * @param {Number} walletId ID du portefeuille
     * @param {Object} params Paramètres de filtrage
     * @param {Number} [params.per_page] Nombre d'éléments par page (défaut: 15, max: 100)
     * @param {String} [params.type] Type de transaction (credit, debit, refund)
     * @param {String} [params.start_date] Date de début (format: YYYY-MM-DD)
     * @param {String} [params.end_date] Date de fin (format: YYYY-MM-DD)
     * @param {String} [params.sort_direction] Direction du tri (asc, desc)
     * @returns {Promise} Réponse de l'API avec les transactions du portefeuille
     */
    getWalletTransactionsByWallet(walletId, params = {}) {
        return ApiService.get(`/wallet-transactions/wallet/${walletId}`, params);
    }

    /**
     * Récupérer les statistiques des transactions
     * @param {Object} params Paramètres de filtrage
     * @param {Number} [params.customer_id] ID du client
     * @param {Number} [params.wallet_id] ID du portefeuille
     * @param {String} [params.start_date] Date de début (format: YYYY-MM-DD)
     * @param {String} [params.end_date] Date de fin (format: YYYY-MM-DD)
     * @returns {Promise} Réponse de l'API avec les statistiques
     */
    getWalletTransactionStats(params = {}) {
        return ApiService.get('/wallet-transactions/stats', params);
    }

    /**
     * Récupérer les transactions récentes
     * @param {Object} params Paramètres
     * @param {Number} [params.limit] Nombre de transactions à récupérer (défaut: 10, max: 50)
     * @returns {Promise} Réponse de l'API avec les transactions récentes
     */
    getRecentWalletTransactions(params = {}) {
        return ApiService.get('/wallet-transactions/recent', params);
    }

    /**
     * Exporter les transactions (retourne les données pour export)
     * @param {Object} params Paramètres de filtrage
     * @param {String} [params.type] Type de transaction (credit, debit, refund)
     * @param {Number} [params.customer_id] ID du client
     * @param {Number} [params.wallet_id] ID du portefeuille
     * @param {String} [params.start_date] Date de début (format: YYYY-MM-DD)
     * @param {String} [params.end_date] Date de fin (format: YYYY-MM-DD)
     * @returns {Promise} Réponse de l'API avec les transactions à exporter
     */
    exportWalletTransactions(params = {}) {
        return ApiService.get('/wallet-transactions/export', params);
    }
}

export default new CustomerWalletTransactionService();
